import React from "react";
import { PageHead } from "../pages/work/WorkUi";
import "../assets/css/FinanceManagement.css";

/** Standard page heading for admin finance pages; the plain-English hint sits in the Info pill. */
export default function FinancePageHead({ section, title, hint, children }) {
  return (
    <PageHead title={title || section?.label} info={hint ?? section?.hint}>
      {children}
    </PageHead>
  );
}

/** Underlined tabs on desktop, pills on narrow screens (same look as the old Finance tabs). */
export function FinanceTabs({ tabs, active, onChange, ariaLabel }) {
  return (
    <div className="page-header finance-section-tabs">
      <div className="page-header-row">
        <div className="tabs-container">
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              className={`tab-button ${active === t.key ? "active" : ""}`}
              onClick={() => onChange(t.key)}
            >
              {t.label}
              {t.count != null ? <span className="finance-tab-count">{t.count}</span> : null}
            </button>
          ))}
        </div>
        <div className="finance-tab-pills" role="tablist" aria-label={ariaLabel}>
          {tabs.map((t) => (
            <button
              key={t.key}
              type="button"
              role="tab"
              aria-selected={active === t.key}
              className={`finance-tab-pill${active === t.key ? " is-active" : ""}`}
              onClick={() => onChange(t.key)}
            >
              {t.label}
              {t.count != null ? ` (${t.count})` : ""}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}

/** Summary tiles (amount + label); a tile with onClick acts as a quick filter. */
export function FinanceStats({ items }) {
  return (
    <div className="finance-stats">
      {items.map((item) => {
        const Icon = item.icon;
        const content = (
          <>
            {Icon ? (
              <span className="finance-stat__icon" aria-hidden="true">
                <Icon />
              </span>
            ) : null}
            <span className="finance-stat__value">{item.value}</span>
            <span className="finance-stat__label">{item.label}</span>
            {item.hint ? <span className="finance-stat__hint">{item.hint}</span> : null}
          </>
        );
        const className = `finance-stat finance-stat--${item.tone || "neutral"}`;
        return item.onClick ? (
          <button key={item.key} type="button" className={className} onClick={item.onClick}>
            {content}
          </button>
        ) : (
          <div key={item.key} className={className}>
            {content}
          </div>
        );
      })}
    </div>
  );
}
